import React from 'react';

import {translate} from '~/decorators';
import classnames from 'classnames';

import './index.scss';
import parseResultIntoRuns from '../../../../utils/parseResultIntoRuns';

const PROFILES_URL = process.env.REACT_APP_PROFILES_URL;

const DuelCompetitor = ({className, groupIndex, isHighestRank, roundType, athlete, result, colors, t, eventId}) => {
  const refinedRoundType = roundType.toLowerCase();
  const athletePhotoUrl = `${PROFILES_URL}/${eventId}/` + (athlete.filename ? athlete.filename : 'unknown.png');
  let totalValue = result.value;
  if (refinedRoundType === 'time') {
    const columnInformation = result.details && result.details.find((detail) => detail.name === 'ColumnInformation');
    const value = columnInformation && columnInformation.details && columnInformation.details[0] && columnInformation.details[0].values && columnInformation.details[0].values[0];
    totalValue = value || '';
  }

  return (
    <div className={classnames(className)}>
        <img
          className="competitor-photo"
          src={athletePhotoUrl}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = `${PROFILES_URL}/unknown.png`;
          }}
          alt={t('Profile')}
        />
      <span className="competitor-name">
        {athlete.fullName}
        <span>
          {athlete.nationality}
        </span>
      </span>
      <div className="scores-overview">
        <div className="score-box">
          <span className="title">{t('Rank')}</span>
          {result.rank}
        </div>
        <div className="score-box">
          <span className="title">{refinedRoundType === 'time' ? t('Time') : t('Total')}</span>
          {totalValue}
        </div>
      </div>
      <ul className="scores-list">
        {parseResultIntoRuns(result).map((run, i) => {
          let style = run.isHighlighted ? colors.highlight : colors.nonCounting;
          if (athlete.isLive) {
              style = run.isHighlighted ? colors.highlightActive : colors.nonCounting;
          }
          if (run.isDrop) {
              style = colors.drop;
          }
          return (
            <li
              key={`score_${groupIndex}_${result.externalId}_${i}`}
              className="score-box"
              style={style}>{run.value}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default translate('home.duel.competitor')(DuelCompetitor)


// WEBPACK FOOTER //
// ./src/views/Home/duel/DuelCompetitor/index.js